module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.5659/images/default-avatar.png"